const SettingKeys = {
  BUSINESS_START_TIME: "BUSINESS_START_TIME",
  BUSINESS_END_TIME: "BUSINESS_END_TIME",
};
export default SettingKeys;
